export default __webpack_public_path__ + "static/media/kubernetes.5361c558.svg";